
<div mat-dialog-title class="heading-container">
    <button mat-icon-button mat-dialog-close>
        <mat-icon aria-hidden="true">arrow_back</mat-icon>
    </button>
    <span>{{data.heading}}</span>
</div>
<mat-dialog-content>
    <app-faq [orderData]="data" (refresh)="needRefresh=true"></app-faq>
</mat-dialog-content>
